const orderApproveCardConfig = {
  btnClass: {arrowUp: 'el-icon-arrow-up', arrowDown: 'el-icon-arrow-down'},
  collapseButton: {
    text: {current: '', show: '展开所有', hide: '折叠所有'},
    flag: true
  },
  detailButton: {
    text: {current: '', show: '显示详情', hide: '隐藏详情'},
    showDetails: true
  },
  approveInfo: {
    title: {text: '审批信息', btnClass: 'el-icon-arrow-up'},
    visible: true
  },
  loanConfirmInfo: {
    title: {text: '放款前确认', btnClass: 'el-icon-arrow-up'},
    visible: true
  },
  mortgageConfirmInfo: {
    title: {text: '抵押资料收到确认', btnClass: 'el-icon-arrow-up'},
    visible: true
  },
  baseInfo: {
    title: {text: '基础信息', btnClass: 'el-icon-arrow-up'},
    visible: true
  },
  proposerInfo: {
    title: {text: '申请人信息', btnClass: 'el-icon-arrow-up'},
    visible: true
  },
  puFaInfo: {
    title: {text: '浦发业务专项字段', btnClass: 'el-icon-arrow-up'},
    visible: true
  },
  workBackground: {
    title: {text: '工作背景', btnClass: 'el-icon-arrow-up'},
    visible: true
  },
  vehicleInfo: {
    title: {text: '车辆信息', btnClass: 'el-icon-arrow-up'},
    visible: true
  },
  loanInfo: {
    title: {text: '贷款信息', btnClass: 'el-icon-arrow-up'},
    visible: true
  },
  guaranteeInfo: {
    title: {text: '担保人信息', btnClass: 'el-icon-arrow-up'},
    visible: true
  },
  publicCardInfo: {
    title: {text: '公牌信息', btnClass: 'el-icon-arrow-up'},
    visible: true
  },
  grantAccountInfo: {
    title: {text: '放款账户信息', btnClass: 'el-icon-arrow-up'},
    visible: true
  },
  thirdPartyCheckResult: {
    title: {text: '第三方检测结果', btnClass: 'el-icon-arrow-up'},
    visible: true
  },
  creditReportAttachmentsInfo: {
    title: {text: '征信报告附件信息', btnClass: 'el-icon-arrow-up'},
    visible: true
  },
  orderAttachmentsInfo: {
    title: {text: '申请单附件信息', btnClass: 'el-icon-arrow-up'},
    visible: true
  },
  approvalHistory: {
    title: {text: '历史审批信息', btnClass: 'el-icon-arrow-up'},
    visible: true
  },
  relativeInfo: {
    title: {text: '配偶信息', btnClass: 'el-icon-arrow-up'},
    visible: true
  }
}
export {
  orderApproveCardConfig
}



// WEBPACK FOOTER //
// ./src/assets/js/page/approval/refs/approve.page.cardConfig.js